export default (tratt) => {
  return tratt?.toLowerCase?.().replace(/ /g, "-")
}
